import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Account } from 'app/shared/models/account';
import { map, Observable } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {

  constructor(private commonService: CommonService, private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.commonService.getWebsiteMaintenanceStatus().pipe(
      map((maintenance: boolean) => {
        if (maintenance) {
          this.router.navigate(['/maintenance']);
          return false;
        }
        return true;
      })
    );
  }
}
